import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const BearCallSpreadSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path d="M1.02043 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
    <path d="M1 11.3615H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
    <path d="M1.28916 6.18963H7.74366L11.765 11.3386" stroke="#089981" strokeWidth="2"/>
    <path d="M11.765 11.3385L21.5078 23.2032H30.8324" stroke="#A40C0C" strokeWidth="2"/>
</svg>)

const BearCallSpread: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {BearCallSpreadSvg(props)}
    </SvgIcon>
));
export default BearCallSpread
